module.exports = __webpack_public_path__ + "img/signup-grp3.6ed7719d.png";